import React from 'react';
import Image from 'react-bootstrap/Image';

const PoweredBy: React.FC = () => (
    <div className="powered-by">
        <p>Powered by:</p>
        <a href="https://www.findata.nl" target="_blank" rel="noopener noreferrer">
            <Image src="/logos/findata.png" alt="FinData" />
        </a>
    </div>
);

export default PoweredBy;
